import React from "react";
import {makeStyles} from "@material-ui/core";
import TextView from "./TextView";
import {ColorBackground, ColorFieldBorder, ColorPreviewBorder, ColorTheme, ColorTitle} from "../../../styles/Colors";
import {FormattedMessage} from "react-intl";
import {BORDER_RADIUS, FONT_WEIGHT_MEDIUM} from "../../../styles/Styles";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  viewPreviewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS + 4,
    backgroundColor: ColorPreviewBorder,
    padding: 5,
    alignItems: 'center',
    overflow: 'hidden',
  },
  viewPreview: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
  },
  headerPreview: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: BORDER_RADIUS + 2,
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS
  },
  headerBottomPreview: {
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS,
    width: '100%',
    height: BORDER_RADIUS,
    marginBottom: -BORDER_RADIUS,
    marginTop: -BORDER_RADIUS
  },
}));

const ActivityPreviewView = (props) => {
  const classes = useStyles();

  return (
      <Paper elevation={1} className={classes.viewPreviewWrapper}>
        {/*<div className={classes.headerPreview}>*/}
        {/*  <TextView variant={'body2'} textAlign={'center'} color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} ><FormattedMessage id={props.textId || 'activity.previewR'}/></TextView>*/}
        {/*</div>*/}
        {/*<div className={classes.headerBottomPreview} />*/}
        <div className={classes.viewPreview}>
          {props.children}
        </div>
      </Paper>
  );
};

export default ActivityPreviewView;
